import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { eligiblePartners } from "@/lib/partnerRules";

export default function PartnerPanel({ goal, propertyType }) {
  const [config, setConfig] = useState(null);
  useEffect(() => {
    const controller = new AbortController();
    let active = true;
    fetch("/partners.json", {
      signal: controller.signal,
      credentials: "omit",
      referrerPolicy: "no-referrer",
      cache: "no-store",
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((value) => {
        if (active) setConfig(value);
      })
      .catch(() => {
        if (active) setConfig(null);
      });
    return () => {
      active = false;
      controller.abort();
    };
  }, []);

  const [partner] = eligiblePartners(config, { goal, propertyType });
  if (!partner) return null;
  return (
    <aside
      className="research-card partner-panel"
      aria-label="Optional partner"
    >
      <span className="eyebrow">Partner · optional</span>
      <h3>{partner.name}</h3>
      <p>
        {partner.id === "r2"
          ? "Prop AI is operated by R2 Real Estate Co PTY LTD"
          : `${partner.name} is a referral partner of Prop AI${partner.sameFounders ? " and is owned by the same founders" : ""}`}
        . Prop AI's analysis is the same whether or not you use {partner.name}.
      </p>
      <p>
        {partner.remuneration === "unconfirmed"
          ? "Referral remuneration arrangements are not yet confirmed."
          : partner.remuneration === "none"
            ? "Prop AI receives no referral payment or benefit from this partner."
            : partner.benefitDisclosure}
      </p>
      <a
        href={partner.website}
        target="_blank"
        rel="noopener noreferrer"
        referrerPolicy="no-referrer"
      >
        {partner.cta} (opens a new tab)
      </a>
      <p className="source">
        This link opens a separate website. Your Prop AI report, financial
        scenarios and account details are not included in the link. Enquiries
        you make there are handled by that business.
      </p>
      <Link to="/independence">How Prop AI stays independent</Link>
    </aside>
  );
}
